import VueTypes from 'vue-types';

export const BlogItem = VueTypes.shape({
    title: VueTypes.oneOfType([String, null]).isRequired,
    img: VueTypes.oneOfType([String, null]).isRequired,
    date: VueTypes.oneOfType([String, null]).isRequired,
    url: VueTypes.oneOfType([String, null]).isRequired
}).isRequired

export const createBlogItem = ({ title, img, date, url }) => {
    return {
        title: title,
        img: img,
        date: date,
        url: url,
    }
}
